export default "__VITE_ASSET__DgxHIchA__"